export const FIELD = {
    USERNAME: 'username',
    PASSWORD: 'password',
}

export const LOCALE_PREFIX = 'scenes.Login.components.LoginForm'
